module.exports = __webpack_public_path__ + "img/mw.mw83c32d5.svg";